import React, { Component } from "react";
import NavBar from "../Componentes/NavBar";
import Tabs from "../Componentes/Tabs";
import AgregaVIP from "../Componentes/AgregaVIP";
import Grid from "@material-ui/core/Grid";
import CartaVIP from "../Componentes/CartaVIP";
import "./Eventos.css";
import FadeIn from "react-fade-in";
import fire from "../config/Fire";

class vip extends Component {
  constructor() {
    super();
    this.state = {
      pictures: [],
      picturesa: []
    };
  }
  //realiza la consulta de los posts
  componentDidMount() {
    fire.auth().onAuthStateChanged(user => {
      if (user) {
        fire
          .database()
          .ref()
          .child("Posts")
          .on("value", snapshot => {
            this.setState({ pictures: [] });
            Object.entries(snapshot.val()).map(ids => {
              return this.setState({
                pictures: this.state.pictures.concat(ids[1])
              });
            });
            //this.setState({ pictures: this.state.picturesa.reverse() });
          });
      }
    });
  }
  //realiza el render de los componentes
  render() {
    return (
      <div>
        <NavBar />
        <Tabs />
        <FadeIn>
          <div className="content">
            <Grid container spacing={40} alignItems="center">
              <Grid item xs={12}>
                <AgregaVIP />
              </Grid>
            </Grid>
            <Grid container spacing={24} alignItems="center">
              {this.state.pictures.map(card => {
                return (
                  <Grid item sm={6} md={4} lg={3}>
                    <CartaVIP
                      title={card.titulo}
                      tipo={card.tipo}
                      link={card.link}
                      contenido={card.contenido}
                    />
                  </Grid>
                );
              })}
            </Grid>
          </div>
        </FadeIn>
      </div>
    );
  }
}

export default vip;
